/* Temporary to overcome nasty message in console for unlicensed ag-Grid */
export const suppressAgGridLicenseConsoleError = (): void => {
    const original = console.error;

    console.error = (...args: unknown[]) => {
        const firstArg = args[0];
        if (typeof firstArg === 'string' && (firstArg.includes('******************************') || firstArg.toLowerCase().includes('* '))) {
            return;
        }
        original.apply(console, args);
    };
};

/**
 * TODO: Three.js r175+ deprecates `THREE.Clock` in favor of `THREE.Timer`; @thatopen/components
 * still uses `Clock` until a release migrates. Dev-only: hide the known noise.
 */
export const suppressThreeClockDeprecationWarning = (): void => {
    if (!import.meta.env.DEV) {
        return;
    }
    const original = console.warn;
    console.warn = (...args: unknown[]) => {
        const first = args[0];
        const text =
            typeof first === 'string' ? first : first != null && typeof (first as { toString?: () => string }).toString === 'function' ? String(first) : '';
        if (text.includes('Clock') && text.includes('deprecated') && text.includes('Timer') && (text.includes('THREE') || text.includes('three.js'))) {
            return;
        }
        original.apply(console, args);
    };
};
